import { Typography, IconButton, makeStyles, Avatar, Button, Grid, Tooltip } from '@material-ui/core';
import React from 'react';
import ApprovalViewer from './ApprovalViewer';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import SourceViewerDialogFields from '../../ManageAsset/Sources/SourceViewerDialogFields';
import { getLocalDateTime } from '../../../Utils/GlobalUtils';
import { formatBytes } from '../../../Utils/GlobalUtils';
import ArtifactViewerDialogFields from '../../ManageAsset/OutPut/ArtifactViewerDialogFields';
import ArtifactStatusDropdownContainer from '../../ManageAsset/ArtifactStatusDropdownContainer';

const useStyles = makeStyles((theme) => ({
	root: {
		margin: 0,
		padding: theme.spacing(2),
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: theme.palette.grey[500],
	},
	sourceAvatar: {
		width: '8em',
		height: '8.5em',
	},
	approvalViewer: {
		'& iframe': {
			width: '35em',
			height: '35em',
		},
	},
}));

// adding close button for dialog.
const DialogTitle = (props) => {
	const { children, classes, onClose, ...other } = props;
	return (
		<MuiDialogTitle disableTypography className={classes.root} {...other}>
			<Typography variant="h6">{children}</Typography>
			{onClose ? (
				<IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
					<CloseIcon />
				</IconButton>
			) : null}
		</MuiDialogTitle>
	);
};
// Source and artifact side by side view.
const SourceAndArtifactCompareView = ({ sourceUrl, artifactUrl, srcFile, artifact, asset }) => {
	return (
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<ArtifactStatusDropdownContainer asset={asset} sourceFile={srcFile} artifact={artifact} />
			</Grid>
			<Grid item xs={6}>
				<Grid item xs={12}>
					<ApprovalViewer modelUrl={sourceUrl} />
				</Grid>
				<Grid item xs={12}>
					<SourceViewerDialogFields
						name={srcFile.name}
						createdDate={getLocalDateTime(srcFile.createdAt)}
						size={formatBytes(srcFile.size)}
					/>
				</Grid>
			</Grid>
			<Grid item xs={6}>
				<Grid item xs={12}>
					<ApprovalViewer modelUrl={artifactUrl} />
				</Grid>
				<Grid item xs={12}>
					<ArtifactViewerDialogFields
						name={artifact.name}
						createdDate={getLocalDateTime(artifact.createdAt)}
						size={artifact.size}
						sourceFileSize={srcFile.size}
					/>
				</Grid>
			</Grid>
		</Grid>
	);
};

// parent container to render approval viewer.
const ArtifactViewerDialog = ({
	label,
	sourceModelUrl,
	artifactModelUrl,
	size,
	type,
	srcFile,
	artifact,
	asset,
	imageUrl,
}) => {
	const classes = useStyles();
	const [open, setOpen] = React.useState(false);
	const handleClose = () => {
		setOpen(false);
	};
	const handleClickOpen = () => {
		setOpen(true);
	};
	const titleProps = {
		classes,
		onClose: handleClose,
	};
	const ArtifactAvatar = () => {
		const isUsdz = type.toLowerCase() === 'usdz';
		const BtnElm = (
			<Button onClick={handleClickOpen} disabled={isUsdz}>
				<Avatar src={imageUrl} variant="square" className={classes.sourceAvatar}>
					Artifact File
					{/* Only display Zoom in icon for GLB Avatar, for better UI/UX. since approval viewer is disabled for USDZ.  */}
					{isUsdz ? '' : <ZoomInIcon />}
				</Avatar>
			</Button>
		);
		// Add disabled tooltip for USDZ artifacts. since they cannot be viewed on Approval viewer.
		if (isUsdz) {
			return (
				<Tooltip title="Usdz Files cannot be viewed on Approval Viewer" arrow={true} placement="top">
					<span>{BtnElm}</span>
				</Tooltip>
			);
		}
		return BtnElm;
	};
	return (
		<>
			<ArtifactAvatar />
			<Dialog
				open={open}
				className={classes.dialog}
				fullWidth={true}
				onClose={handleClose}
				aria-labelledby="artifact-viewer-dialog"
				data-cy="artifact-viewer-dialog"
				maxWidth="lg"
			>
				<DialogTitle id="artifact-viewer-dialog" {...titleProps}>
					{label}
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="artifact-viewer-dialog"></DialogContentText>
					<div className={classes.approvalViewer}>
						{open ? (
							<SourceAndArtifactCompareView
								sourceUrl={sourceModelUrl}
								artifactUrl={artifactModelUrl}
								srcFile={srcFile}
								artifact={artifact}
								asset={asset}
							/>
						) : (
							''
						)}
					</div>
				</DialogContent>
			</Dialog>
		</>
	);
};

export default ArtifactViewerDialog;
